// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"Breadcrumb_Breadcrumb__17Ctn","breadcrumbItem":"Breadcrumb_breadcrumbItem__3SzQX","breadcrumbArrow":"Breadcrumb_breadcrumbArrow__1Fz9R"};